/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Speakers_No_SpeakersInputs */



/**
* | output |
* | --- |
* | "No Speaker(s) Assigned" |
*
* @param {Event_Speakers_No_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_speakers_no_speakers = /** @type {((inputs?: Event_Speakers_No_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Speakers_No_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun locuteur assigne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein/e Sprecher/in zugewiesen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun relatore assegnato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Докладчик(и) не назначены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay oradores asignados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未指定发言人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者が割り当てられていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई वक्ता नियुक्त नहीं किया गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum palestrante designado")
	return /** @type {LocalizedString} */ ("No Speaker(s) Assigned")
});